import { Box, Button, Container, Grid, IconButton, ListItemButton, OutlinedInput, Stack, styled, Typography, useMediaQuery, useTheme } from "@mui/material";
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import MDBox from "../MDBox";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import { IAuthState, IUser } from "../../stateManagement/reducers/authReducer";
import { userIsAuthenticated } from "../../stateManagement/helpers";
import { pathContains } from "../../helpers";
import { IOrdersState } from "../../stateManagement/reducers/ordersReducer";
import { MAX_MEMBERSHIP_TYPE } from "../../config/constants";

const Footer = () => {

    const navigate = useNavigate();
    const theme = useTheme();
    const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));
    const location = useLocation();
    const { user, authToken } = useSelector<IRootReducerT, IAuthState>(state => state.auth);
    const { activeMembership } = useSelector<IRootReducerT, IOrdersState>(state => state.orders);

    const title = process.env.REACT_APP_APP_NAME;
    const slogan = process.env.REACT_APP_SLOGAN;

    const officeAddress = "Suite 7, Law Hub, Ring Road, Ibadan";

    const line1 = "+234 818 856 6937";
    const line2 = "+234 812 999 1303";

    const [email, setEmail] = useState("");

    const quickLinks1 = (user && userIsAuthenticated(user as IUser)) ? [
        {
            id: 'welcome',
            title: 'Home',
            type: 'item',
            url: '/welcome',
            userAuth: false     //user-authentication is not a pre-requisite for visiting this  page
        },
        (activeMembership && (activeMembership.rentalPackage.rentalItems[0].name === MAX_MEMBERSHIP_TYPE)) ? {
            id: (user && userIsAuthenticated(user as IUser)) ? 'resource-hub' : 'gallery',
            title: 'Resources',
            type: 'item',
            url: (user && userIsAuthenticated(user as IUser)) ? '/member/resource-hub' : '/resources/gallery',
            userAuth: false
        } : {
            id: 'memberships',
            title: 'Memberships',
            type: 'item',
            url: '/memberships',
            userAuth: false
        },
        {
            id: (user && userIsAuthenticated(user as IUser)) ? 'other-services' : 'consultancy',
            title: 'Services',
            type: 'item',
            url: (user && userIsAuthenticated(user as IUser)) ? '/services/other-services' : '/services/consultancy',
            userAuth: false
        },
        {
            id: 'our-team',
            title: 'Our Team',
            type: 'item',
            url: '/about/our-team',
            userAuth: false
        },
    ] : [
        {
            id: 'welcome',
            title: 'Home',
            type: 'item',
            url: '/welcome',
            userAuth: false     //user-authentication is not a pre-requisite for visiting this  page
        },
        {
            id: 'our-team',
            title: 'Our Team',
            type: 'item',
            url: '/about/our-team',
            userAuth: false
        },
        {
            id: 'testimonials',
            title: 'Testimonials',
            type: 'item',
            url: '/testimonials',
            userAuth: false
        },
        {
            id: (user && userIsAuthenticated(user as IUser)) ? 'other-services' : 'consultancy',
            title: 'Services',
            type: 'item',
            url: (user && userIsAuthenticated(user as IUser)) ? '/services/other-services' : '/services/consultancy',
            userAuth: false
        },
    ]

    const quickLinks2 = (user && userIsAuthenticated(user as IUser)) ? [
        {
            id: 'testimonials',
            title: 'Testimonials',
            type: 'item',
            url: '/testimonials',
            userAuth: false
        },
        {
            id: 'faq',
            title: 'FAQs',
            type: 'item',
            url: '/faq',
            userAuth: false
        },
        {
            id: 'contact-us',
            title: 'Contact Us',
            type: 'item',
            url: '/about/contact-us',
            userAuth: false
        },
        {
            id: 'terms-and-conditions',
            title: 'Terms & Conditions',
            type: 'item',
            url: '/terms-and-conditions',       //TODO: set route to terms & conditions page
            userAuth: false
        }
    ] : [
        {
            id: 'memberships',
            title: 'Memberships',
            type: 'item',
            url: '/memberships',
            userAuth: false
        },
        {
            id: (user && userIsAuthenticated(user as IUser)) ? 'resource-hub' : 'gallery',
            title: 'Resources',
            type: 'item',
            url: (user && userIsAuthenticated(user as IUser)) ? '/member/resource-hub' : '/resources/gallery',
            userAuth: false
        },
        {
            id: 'faq',
            title: 'FAQs',
            type: 'item',
            url: '/faq',
            userAuth: false
        },
        {
            id: 'terms-and-conditions',
            title: 'Terms & Conditions',
            type: 'item',
            url: '/terms-and-conditions',       //TODO: set route to terms & conditions page
            userAuth: false
        }
    ]

    const socialMediaData = [
        {
            url: "",
            platform: "X",
            icon: <XIcon sx={{ height: "1.25rem", width: "1.25rem", color: "white" }} />
        },
        {
            url: "",
            platform: "Facebook",
            icon: <FacebookIcon sx={{ height: "1.25rem", width: "1.25rem" }} />
        },
        {
            url: "",
            platform: "Instagram",
            icon: <InstagramIcon sx={{ height: "1.25rem", width: "1.25rem" }} />
        },
    ];

    const logoHeight = '8rem';
    const LogoImg = styled('img')(() => ({
        height: '100%',
        width: 'auto !important',
        flex: '0 !important',
        margin: 'auto',
    }));

    return (
        <Stack
            alignItems="center"
            sx={{
                backgroundColor: "dark.focus",
                width: "100%",
                marginTop: "0 !important",
                py: {
                    xs: "2rem !important",
                    md: "2rem !important"
                },
                pb: "2rem",
                px: "1rem"
            }}
        >
            <Grid
                container
                sx={{
                    width: "100%",
                    maxWidth: "1800px !important"
                }}
                justifyContent="space-around"
            >
                <Grid item xs={12} md="auto" spacing={4} >
                    <Stack
                        alignItems={idGreaterThanMd ? "flex-start" : "center"}
                        spacing={4}
                        sx={{

                        }}
                    >
                        <Box sx={{ display: { xs: 'none', md: 'flex' }, height: logoHeight }} >
                            <IconButton
                                onClick={() => {
                                    window.open("/", "_self");
                                }}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "transparent !important"
                                    }
                                }}
                            >
                                <LogoImg src="/images/darkLogo.png" />
                            </IconButton>
                        </Box>
                        <Typography
                            variant="body1"
                            sx={{
                                mt: "2rem",
                                textAlign: { xs: "center", md: "left" },
                                color: "white !important",
                                fontWeight: "400",
                                fontSize: "0.75rem !important",
                                lineHeight: "1.875rem !important",
                                cursor: "pointer",
                                maxWidth: "20.125rem",
                            }}
                            onClick={() => {
                                // Encode the address to make it URL-safe
                                const encodedAddress = encodeURIComponent(officeAddress);

                                // Create the Google Maps URL with the encoded address
                                const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

                                // Open the Google Maps URL in a new tab
                                window.open(googleMapsUrl, '_blank');
                            }}
                        >Thank you for choosing SME Scaleup to support your business journey. Together, let's elevate your success. Reach out to us for any assistance or inquiries – we're here to help you thrive!</Typography>
                        {/* <Stack
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            spacing={8}
                        >
                            {
                                socialMediaData.map((data, index) => {
                                    return (
                                        <Box
                                            key={index}
                                            onClick={() => {
                                                window.open(data.url, "_blank")
                                            }}
                                            sx={{
                                                color: "white !important",
                                                cursor: "pointer",
                                                transition: "all .25s linear 0s",
                                                "&:hover": {
                                                    transform: "scale(110%, 110%)"
                                                }
                                            }}
                                        >{data.icon}</Box>
                                    );
                                })
                            }
                        </Stack> */}
                    </Stack>
                </Grid>
                <Grid item xs={6} md="auto" sx={{ ml: { xs: "0", md: "8rem" } }} >
                    <Stack
                        alignItems={idGreaterThanMd ? "flex-start" : "flex-start"}
                        spacing={3}
                        sx={{

                        }}
                    >
                        <Box sx={{ opacity: "0%", display: { xs: 'none', md: 'flex' }, height: logoHeight }} >
                            <IconButton
                                onClick={() => {
                                    window.open("/", "_self");
                                }}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "transparent !important"
                                    }
                                }}
                            >
                                <LogoImg src="/images/darkLogo.png" />
                            </IconButton>
                        </Box>
                        <Stack alignItems={idGreaterThanMd ? "flex-start" : "center"} >
                            <Typography sx={{ textAlign: { xs: "center", md: "left" }, color: "white !important", fontSize: "1.25rem", fontWeight: "600" }} >Quick Links</Typography>
                            {
                                quickLinks1.map((quickLink, i) => {
                                    return (
                                        <ListItemButton
                                            sx={{
                                                pl: "0 !important"
                                            }}
                                            onClick={() => {
                                                window.open(quickLink.url, '_self');
                                            }}
                                            key={i} >
                                            <Typography
                                                sx={{
                                                    color: pathContains(location.pathname, quickLink.id) ? '#3cacfe !important' : 'white !important'
                                                }}
                                                variant="body1"
                                            >{quickLink.title}</Typography>
                                        </ListItemButton>
                                    );
                                })
                            }
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item xs={6} md="auto">
                    <Stack
                        alignItems={idGreaterThanMd ? "flex-start" : "flex-end"}
                        spacing={3}

                        sx={{

                        }}
                    >
                        <Box sx={{ opacity: "0%", display: { xs: 'none', md: 'flex' }, height: logoHeight }} >
                            <IconButton
                                onClick={() => {
                                    window.open("/", "_self");
                                }}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "transparent !important"
                                    }
                                }}
                            >
                                <LogoImg src="/images/darkLogo.png" />
                            </IconButton>
                        </Box>
                        <Stack alignItems={idGreaterThanMd ? "flex-start" : "center"} >
                            <Typography sx={{ textAlign: { xs: "center", md: "left" }, color: "white !important", fontSize: "1.25rem", fontWeight: "600" }} >Quick Links</Typography>
                            {
                                quickLinks2.map((quickLink, i) => {
                                    return (
                                        <ListItemButton
                                            onClick={() => {
                                                window.open(quickLink.url, '_self')
                                            }}
                                            sx={{
                                                pl: "0 !important"
                                            }}
                                            key={i} >
                                            <Typography sx={{
                                                color: pathContains(location.pathname, quickLink.id) ? '#3cacfe !important' : 'white !important'
                                            }} variant="body1">{quickLink.title}</Typography>
                                        </ListItemButton>
                                    );
                                })
                            }
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item xs={12} md="auto">
                    <Stack
                        alignItems={idGreaterThanMd ? "flex-start" : "flex-start"}
                        spacing={3}

                        sx={{

                        }}
                    >
                        <Box sx={{ opacity: "0%", display: { xs: 'none', md: 'flex' }, height: logoHeight }} >
                            <IconButton
                                onClick={() => {
                                    window.open("/", "_self");
                                }}
                                sx={{
                                    "&:hover": {
                                        backgroundColor: "transparent !important"
                                    }
                                }}
                            >
                                <LogoImg src="/images/darkLogo.png" />
                            </IconButton>
                        </Box>
                        <Stack alignItems="flex-start" spacing={2} >
                            <Typography sx={{ color: "white !important", fontSize: "1.25rem", fontWeight: "600" }} >Newsletter</Typography>
                            <Typography sx={{ color: "white !important", fontSize: ".75rem !important" }} variant="body1">Subscribe for the latest updates</Typography>
                            <OutlinedInput
                                id="email-reg"
                                type="email"
                                value={email}
                                name="email"
                                onChange={e => {
                                    setEmail(e.target.value);
                                }}
                                placeholder="Enter your email"
                                fullWidth
                                error={Boolean(false)}
                                sx={{
                                    opacity: '100%',
                                    borderRadius: '0',
                                    border: "1px solid rgba(255, 255, 255, 0.80)",
                                    backgroundColor: "rgba(0, 0, 0, 0.30)",
                                    color: '#FFF !important',
                                    fontStyle: 'italic',
                                    fontWeight: '500',
                                    fontSize: '.75rem',
                                    width: '100%',
                                    maxWidth: '39.375rem !important',
                                    minWidth: '0 !important',
                                    '& .MuiInputBase-input': {
                                        textAlign: 'center',
                                        color: "white !important",
                                        maxWidth: '39.375rem !important',
                                    },
                                    '&::placeholder': {
                                        color: '#FFF !important',
                                        opacity: 1,
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    },
                                }}
                            />
                            <Button
                                variant="contained"
                                size="large"
                                sx={{
                                    backgroundColor: "#3cacfe",
                                    border: "solid #3cacfe 1px",
                                    my: 2,
                                    color: 'white',
                                    "&:hover": {
                                        borderColor: "white !important",
                                        border: "solid white 1px"
                                    }
                                }}
                                onClick={() => {
                                }}
                            ><b>SUBSCRiBE</b></Button>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
            <Container sx={{
                marginTop: "2rem",
                width: "100%",
                maxWidth: "1600px !important",
                height: "1px",
                opacity: "0.5",
                background: "#FFF",
            }} ></Container>
            <Typography
                color="white"
                textAlign="center"
                variant="h3"
                sx={{
                    margin: '0 !important',
                    fontSize: "1.125rem !important",
                    color: "white !important",
                    fontWeight: 400,
                    pt: {
                        xs: "2rem !important",
                        md: '2rem !important'
                    },
                    pb: "2.5rem"
                }}
            >Created By <b
                onClick={() => window.open("/", "_self")}
                style={{
                    color: "white",
                    cursor: "pointer",
                    borderBottom: "Solid .0625ren inherit"
                }}
            >{title}</b> | ALL RIGHTS RESERVED! &copy; 2024
            </Typography>
        </Stack>
    );
}

export default Footer;